const slug = (value = "") =>
  String(value)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");

export const ABILITIES = [
  ["strength", "Strength"],
  ["dexterity", "Dexterity"],
  ["constitution", "Constitution"],
  ["intelligence", "Intelligence"],
  ["wisdom", "Wisdom"],
  ["charisma", "Charisma"],
].map(([id, legacyName]) => ({ id, legacyName }));

export const PATHFINDER_SAVES = [
  { id: "fortitude", legacyName: "Fortitude", abilityId: "constitution" },
  { id: "reflex", legacyName: "Reflex", abilityId: "dexterity" },
  { id: "will", legacyName: "Will", abilityId: "wisdom" },
];

export const RACES = [
  ["human", "Human"],
  ["elf", "Elf"],
  ["dwarf", "Dwarf"],
  ["gnome", "Gnome"],
  ["halfling", "Halfling"],
  ["half-elf", "Half-Elf"],
  ["half-orc", "Half-Orc"],
].map(([id, legacyName]) => ({ id, legacyName }));

export const CHARACTER_CLASSES = [
  ["barbarian", "Barbarian"],
  ["bard", "Bard"],
  ["cleric", "Cleric"],
  ["druid", "Druid"],
  ["fighter", "Fighter"],
  ["monk", "Monk"],
  ["paladin", "Paladin"],
  ["ranger", "Ranger"],
  ["rogue", "Rogue"],
  ["sorcerer", "Sorcerer"],
  ["wizard", "Wizard"],
].map(([id, legacyName]) => ({ id, legacyName }));

export const ALIGNMENTS = [
  ["lawful-good", "Lawful Good"],
  ["neutral-good", "Neutral Good"],
  ["chaotic-good", "Chaotic Good"],
  ["lawful-neutral", "Lawful Neutral"],
  ["true-neutral", "True Neutral"],
  ["chaotic-neutral", "Chaotic Neutral"],
  ["lawful-evil", "Lawful Evil"],
  ["neutral-evil", "Neutral Evil"],
  ["chaotic-evil", "Chaotic Evil"],
].map(([id, legacyName]) => ({ id, legacyName }));
const SKILL_DEFINITIONS = [
  ["acrobatics", "Acrobatics", "dexterity"],
  ["appraise", "Appraise", "intelligence"],
  ["bluff", "Bluff", "charisma"],
  ["climb", "Climb", "strength"],
  ["craft", "Craft", "intelligence"],
  ["diplomacy", "Diplomacy", "charisma"],
  ["disable-device", "Disable Device", "dexterity"],
  ["disguise", "Disguise", "charisma"],
  ["escape-artist", "Escape Artist", "dexterity"],
  ["fly", "Fly", "dexterity"],
  ["handle-animal", "Handle Animal", "charisma"],
  ["heal", "Heal", "wisdom"],
  ["intimidate", "Intimidate", "charisma"],
  ["knowledge-arcana", "Knowledge (Arcana)", "intelligence"],
  ["knowledge-dungeoneering", "Knowledge (Dungeoneering)", "intelligence"],
  ["knowledge-engineering", "Knowledge (Engineering)", "intelligence"],
  ["knowledge-geography", "Knowledge (Geography)", "intelligence"],
  ["knowledge-history", "Knowledge (History)", "intelligence"],
  ["knowledge-local", "Knowledge (Local)", "intelligence"],
  ["knowledge-nature", "Knowledge (Nature)", "intelligence"],
  ["knowledge-nobility", "Knowledge (Nobility)", "intelligence"],
  ["knowledge-planes", "Knowledge (Planes)", "intelligence"],
  ["knowledge-religion", "Knowledge (Religion)", "intelligence"],
  ["linguistics", "Linguistics", "intelligence"],
  ["perception", "Perception", "wisdom"],
  ["perform", "Perform", "charisma"],
  ["profession", "Profession", "wisdom"],
  ["ride", "Ride", "dexterity"],
  ["sense-motive", "Sense Motive", "wisdom"],
  ["sleight-of-hand", "Sleight of Hand", "dexterity"],
  ["spellcraft", "Spellcraft", "intelligence"],
  ["stealth", "Stealth", "dexterity"],
  ["survival", "Survival", "wisdom"],
  ["swim", "Swim", "strength"],
  ["use-magic-device", "Use Magic Device", "charisma"],
];

export const DEFAULT_SKILLS = SKILL_DEFINITIONS.map(
  ([catalogId, legacyName, abilityId]) => ({
    id: `default-${catalogId}`,
    catalogId,
    legacyName,
    abilityId,
  })
);

export const resolveCatalogId = (value, options) => {
  const normalized = slug(value);
  return (
    options.find(
      (option) =>
        option.id === value ||
        slug(option.legacyName) === normalized ||
        slug(option.id) === normalized
    )?.id || normalized
  );
};

export const resolveAbilityId = (value) => resolveCatalogId(value, ABILITIES);
export const resolveRaceId = (value) => resolveCatalogId(value, RACES);
export const resolveClassId = (value) =>
  resolveCatalogId(value, CHARACTER_CLASSES);
export const resolveAlignmentId = (value) =>
  resolveCatalogId(value, ALIGNMENTS);

export const systemLabelKey = (group, id) => `system.${group}.${id}`;
